import * as React from "react";
import { SVGProps } from "react";
const SvgArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.18 7.211c3.506 2.728 6.192 5.342 7.982 7.767.451.608.452 1.43 0 2.044-1.792 2.426-4.478 5.04-7.983 7.767a1 1 0 0 1-1.228-1.578c2.795-2.175 5.034-4.258 6.677-6.207H7.499a1 1 0 1 1 0-2h15.135c-1.642-1.951-3.884-4.036-6.682-6.215A1 1 0 1 1 17.18 7.21Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArrowRight;
